
















































import Vue from 'vue'
import _ from 'lodash'
import { SecurityArea, SecurityComponent, ShiftFilterScope } from '@/types/enums'
import { PlannedShift } from '@/model/planning/PlannedShift'
import { PLANNING_ASSISTANT_GET_CURRENT_SHIFT } from '@/store/getter-types'
import { CheckedShiftList } from '@/types'
import * as securityService from '@/services/security-service'

interface ComponentData {
  currentShift: any
  showDrawer: boolean
  filterScope: ShiftFilterScope
  filterSearchString: string | null
  showSearch: boolean
  displayShiftList: Array<CheckedShiftList>
  isFilterActive: boolean
  checkedList: Array<CheckedShiftList>
  isCheckedAll: boolean
  headers: any
  headers2: any
}

export default Vue.extend({
  name: 'ShiftList',

  props: {
    drawer: Boolean,
    selectedShift: Object as () => any,
    unselect: Boolean,
    filteredShiftList: Array as () => PlannedShift[]
  },

  data (): ComponentData {
    return {
      currentShift: undefined,
      showDrawer: false,
      filterScope: ShiftFilterScope.AllShifts,
      filterSearchString: null,
      showSearch: false,
      displayShiftList: [],
      isFilterActive: false,
      checkedList: [],
      isCheckedAll: false,
      headers: [
        { text: this.$t('planningPage.employee').toString(), value: 'employee', align: 'start', width: '165px' },
        { text: this.$t('planningPage.addressNumberShort').toString(), value: 'addressNumber', align: 'start', width: '85px' },
        { text: this.$t('planningPage.address').toString(), value: 'addressName', align: 'start', width: '150px'}
      ],
      headers2: [
        { text: this.$t('planningPage.shift').toString(), value: 'title', align: 'start'},
      ],
    }
  },

  computed: {
    currentShiftStore (): PlannedShift | undefined {
      return this.$store.getters[PLANNING_ASSISTANT_GET_CURRENT_SHIFT]
    },

    filterColor (): string {
      return this.isFilterActive ? 'primary' : 'grey'
    },

    filterIconColor (): string {
      return this.isFilterActive ? 'white' : 'grey'
    },

    allowSidebar (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconSidebar)
    },

    isSearchAvailable (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconSearch)
    },

    showAddressTable (): boolean {
      return securityService.isVisible(SecurityArea.Menu, SecurityComponent.Address)
    },
  },

  watch: {
    unselect (newVal): void {
      if (newVal) {
        this.isCheckedAll = false
        this.displayShiftList.forEach((item: CheckedShiftList) => {
          item.isChecked = false
        })
        this.checkedList = []
        this.currentShift = undefined
        this.$emit('shiftSelected', this.currentShift)
      }
    },

    drawer (newVal: boolean): void {
      this.showDrawer = newVal
    },

    selectedShift (newVal: any): void {
      if (newVal) {
        this.isCheckedAll = false
        this.displayShiftList.forEach((item: CheckedShiftList) => {
          item.isChecked = false
        })
        this.checkedList = []
        this.currentShift = this.displayShiftList.find((item: CheckedShiftList) => item.projectSerie === newVal.projectSerieId)
        this.currentShift.isChecked = true
        this.$emit('shiftSelected', this.currentShift)
      } else {
        this.displayShiftList.forEach((item: CheckedShiftList) => {
          item.isChecked = false
        })

        if (this.checkedList.length > 1) {
          this.displayShiftList.forEach((item: CheckedShiftList) => {
            this.checkedList.forEach((i: CheckedShiftList) => {
              if (i.projectSerie === item.projectSerie) {
                item.isChecked = true
              }
            })
          })
        }
        this.currentShift = undefined
      }
    },

    filteredShiftList (): void {
      let list: any = []
      list = _.cloneDeep(this.filteredShiftList)

      list.forEach((item: any) => {
        item.isChecked = false
      })
      this.isCheckedAll = false
      this.checkedList = []
      this.displayShiftList = list
    }
  },

  methods: {

    onCheckboxChange (item: CheckedShiftList): void {
      this.checkedList = this.displayShiftList.filter((item: CheckedShiftList) => item.isChecked)
      this.currentShift = item

      if (this.checkedList.length < 1) {
        this.isCheckedAll = false
        this.$emit('shiftSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      } else if (this.checkedList.length === 1) {
        this.isCheckedAll = false
        this.$emit('shiftSelected', this.checkedList[0])
        this.$emit('disableEdit', this.checkedList)
      } else {
        this.isCheckedAll = false
        this.$emit('shiftSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      }
    },

    onSelectAllChange (item: boolean): void {
      if (item) {
        this.displayShiftList.forEach((item: CheckedShiftList) => {
          item.isChecked = true
        })
        this.checkedList = this.displayShiftList
        this.$emit('shiftSelected', undefined)
        this.$emit('disableEdit', this.checkedList)
      } else {
        this.displayShiftList.forEach((item: CheckedShiftList) => {
          item.isChecked = false
        })
        this.checkedList = []
        this.$emit('shiftSelected', undefined)
        this.$emit('disableEdit', this.checkedList)

      }
    },

    onSelectAllClick (): void {
      this.isCheckedAll = !this.isCheckedAll
      this.onSelectAllChange(this.isCheckedAll)
    },

  }

})
